import React, { useState } from 'react';

import { DEMO_PASSWORD } from '../constants';

export function PasswordGate({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    if (typeof window === 'undefined') return false;
    return sessionStorage.getItem('sec-viewer-auth') === 'true';
  });
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    if (password === DEMO_PASSWORD) {
      sessionStorage.setItem('sec-viewer-auth', 'true');
      setIsAuthenticated(true);
      setError(false);
    } else {
      setError(true);
    }
  };

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-navy'>
      <div className='p-8 rounded-xl shadow-2xl bg-white w-full max-w-[380px]'>
        <div className='text-center mb-6'>
          <h1 className='text-xl font-semibold mb-1 text-navy'>
            Meridian Source
          </h1>
          <p className='text-sm text-ink-muted'>Enter password to continue</p>
        </div>
        <form onSubmit={handleSubmit}>
          <input
            type='password'
            value={password}
            onChange={e => {
              setPassword(e.target.value);
              setError(false);
            }}
            placeholder='Password'
            autoFocus
            className={`w-full px-4 py-3 rounded-lg text-sm mb-3 border outline-none ${
              error ? 'border-negative' : 'border-edge'
            }`}
          />
          {error && (
            <p className='text-xs mb-3 text-negative'>Incorrect password</p>
          )}
          <button
            type='submit'
            className='w-full py-3 rounded-lg text-sm font-medium text-white transition-colors bg-navy hover:bg-navy-light'
          >
            Continue
          </button>
        </form>
      </div>
    </div>
  );
}
